exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-item.disabled .page-link {\n  font-weight: bold;\n  color: black;\n  cursor: auto;\n  background-color: #ffc107; }\n\n.tradingStyle {\n  margin-top: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/trading-header/trading-header.component.scss
// module id = ../../../../../src/app/securities-level/trading-header/trading-header.component.scss
// module chunks = main